import React from "react";
import PropTypes from "prop-types";
import TextLink from "./../TextLink";

import {
  StyledContainer,
  StyledCategory,
  StyledLink,
  StyledAuthorName,
  StyledAuthorRole,
} from "./styles";

export const TextLayout = ({
  index = 0,
  context = null,
  clientContext = null,
  key = "text-layout",
  id = "text-layout",
  schema = null,
  title = null,
  linkPath = null,
  summary = null,
  category = null,
  categoryPath = null,
  publishedDate = null,
  authorName = null,
  authorRole = null,
  eventCard = null,
  eventCardTitle = null,
  cardLabel = null,
}) => {
  let { isMobile, isTablet } = clientContext;
  // console.log(linkPath);
  // console.log(authorName, authorRole);
  return (
    <StyledContainer clientContext={clientContext}>
      {category && (
        <TextLink
          linkPath={categoryPath}
          eventCardTitle={category}
          clientContext={clientContext}
          context={context}
          title={category}
          StyledLink={StyledCategory}
        />
      )}
      {linkPath && title && (
        <TextLink
          linkPath={linkPath}
          eventCardTitle={eventCardTitle}
          clientContext={clientContext}
          context={context}
          title={title}
          StyledLink={StyledLink}
        />
      )}

      {authorName && (
        <StyledAuthorName clientContext={clientContext}>
          <div dangerouslySetInnerHTML={{ __html: authorName }} />
        </StyledAuthorName>
      )}
      {authorRole && (
        <StyledAuthorRole clientContext={clientContext}>
          <div dangerouslySetInnerHTML={{ __html: authorRole }} />
        </StyledAuthorRole>
      )}
    </StyledContainer>
  );
};

const TruncateBody = (str, length, ending) => {
  if (str.length > length) {
    return str.substring(0, length) + ending;
  } else {
    return str;
  }
};

export default TextLayout;

TextLayout.propTypes = {
  /**
   Client side variables
  */
  clientContext: PropTypes.object,
  /**
   Server side variables
  */
  context: PropTypes.object.isRequired,
  /**

  */
  index: PropTypes.number,
  /**

  */
  key: PropTypes.string,
  /**

  */
  id: PropTypes.string,
  /**

  */
  schema: PropTypes.string,
  /**

  */
  title: PropTypes.string,
  /**

  */
  linkPath: PropTypes.string,
  /**

  */
  summary: PropTypes.string,
  /**

  */
  category: PropTypes.string,
  /**

  */
  publishedDate: PropTypes.string,
  /**

  */
  authorName: PropTypes.string,
  /**

  */
  authorRole: PropTypes.string,
};
